'use strict';

if (process.env.NODE_ENV === 'production') {
  module.exports = require('./cjs/history.min.js');
} else {
  module.exports = require('./cjs/history.js');
}



//////////////////
// WEBPACK FOOTER
// ./~/history/index.js
// module id = 83
// module chunks = 0